import * as React from 'react';
import Merchant from '../common/Merchant';
import Select from 'react-select';

export interface SettingsInfoProps {
  merchants: Array<Merchant>;
}

interface OptionType {
  label: React.ReactElement<{}>;
  value: string;
}

interface State {
  selectedAccount?: Merchant;
  selectedOption?: OptionType;
}

const customStyles = {
  dropdownIndicator: (base: HTMLElement) => ({
    ...base,
    color: 'black',
    '&:hover': {
      color: 'black',
    },
  }),
};

class SettingsInfo extends React.Component<SettingsInfoProps, State> {
  public constructor(props: SettingsInfoProps) {
    super(props);
    this.state = {};
  }
  private getOptions = () => {
    return this.props.merchants.map((merchant) => ({
      label: (
        <div>
          <span className={`icon ${merchant.charge_type}`}></span>
          {merchant.name} {merchant.trust_account && '- Trust'}
          {merchant.status !== 'ACTIVE' && `(${merchant.status})`}
        </div>
      ),
      value: merchant.id,
    }));
  };
  private handleDropdownChange = (option: OptionType) => {
    const selectedAccount = this.props.merchants.find(
      (element) => element.id === option.value
    );
    this.setState({ selectedOption: option, selectedAccount });
  };

  public render() {
    if (this.props.merchants.length <= 0) {
      return (
        <div className="section side">
          <h1>Start Collecting Payments</h1>
          <h2>Get Started using the Affinipay Plugin Now.</h2>
        </div>
      );
    }
    const options = this.getOptions();
    const selectedAccount =
      this.state.selectedAccount || this.props.merchants[0];
    const selectedOption = this.state.selectedOption || options[0];

    return (
      <div className="section side">
        <h3>Start Collecting Payments</h3>
        Account:
        <Select
          className="accounts-dropdown"
          onChange={this.handleDropdownChange}
          options={options}
          value={selectedOption}
          isSearchable={false}
          components={{
            IndicatorSeparator: () => null,
          }}
          styles={customStyles}
        />
        <p>
          Add the following shortcode to the content area on any page to display
          the payment form.
        </p>
        <textarea
          onClick={(e) => e.currentTarget.select()}
          value={`[affinipay-payment type=${selectedAccount.charge_type} account=${selectedAccount.id}]`}
          readOnly={true}
        />
        {selectedAccount.status !== 'ACTIVE' && (
          <span className={'warning'}>Note: This account is not active</span>
        )}
      </div>
    );
  }
}

export default SettingsInfo;



// WEBPACK FOOTER //
// ./src/settings/SettingsInfo.tsx